export default __webpack_public_path__ + "static/media/windax_3.e23fe9e7.jpg";